import { useState } from 'react';
import { storeService } from '../services/storeService';
import { useToastStore } from '../store/toastStore';

interface ReviewFormState {
  rating: number;
  comment: string;
  submitting: boolean;
}

const EMPTY_FORM: ReviewFormState = { rating: 0, comment: '', submitting: false };

export function useReviewForm(orderId: number, onReviewed: (productId: number) => void) {
  const showToast = useToastStore((s) => s.show);
  const [forms, setForms] = useState<Record<number, ReviewFormState>>({});

  const getForm = (productId: number): ReviewFormState => forms[productId] ?? EMPTY_FORM;

  const setRating = (productId: number, rating: number) => {
    setForms((prev) => ({ ...prev, [productId]: { ...getForm(productId), rating } }));
  };

  const setComment = (productId: number, comment: string) => {
    setForms((prev) => ({ ...prev, [productId]: { ...getForm(productId), comment } }));
  };

  const submit = async (productId: number) => {
    const form = getForm(productId);
    if (form.rating < 1) {
      showToast('Selecione uma nota de 1 a 5 estrelas.', 'error');
      return;
    }

    setForms((prev) => ({ ...prev, [productId]: { ...form, submitting: true } }));
    try {
      await storeService.createReview({ productId, orderId, rating: form.rating, comment: form.comment });
      showToast('Avaliação enviada com sucesso!', 'success');
      onReviewed(productId);
    } catch {
      showToast('Não foi possível enviar sua avaliação. Tente novamente.', 'error');
      setForms((prev) => ({ ...prev, [productId]: { ...form, submitting: false } }));
    }
  };

  return { getForm, setRating, setComment, submit };
}
